// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__180Hi","col":"styles_col__3Bp_R"};